// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1ckTl","choiceBoxes":"toolbarselects_choiceBoxes__2iP1v","simpleField":"toolbarselects_simpleField__3oCbH"};